import { useExternalTrainingModules } from './useExternalTrainingModules';
import { ExternalTrainingModule } from '~/pages/api/courses/_shared/course-form/course-stage-editor/types';
import { Catalog, CatalogItem, CatalogItemContent, CatalogItemHeader } from '~/ui-components';

type ModulesCatalogProps = Readonly<{
   searchTerm: string;
   onSelect: (module: ExternalTrainingModule) => void;
}>;

export function ModulesCatalog({ searchTerm, onSelect }: ModulesCatalogProps) {
   const { data: response } = useExternalTrainingModules(searchTerm);
   const modules = response?.modules;

   return (
      <Catalog>
         {modules?.map(module => (
            <CatalogItem key={module.external_training_moduleid} onClick={() => onSelect(module)}>
               <CatalogItemContent>
                  <CatalogItemHeader>{module.title}</CatalogItemHeader>
               </CatalogItemContent>
            </CatalogItem>
         ))}
      </Catalog>
   );
}
